module.exports = __webpack_public_path__ + "media/images/icon/leaderboard-412aa17ed4dc815bd5044a8215e5a10c.svg";